import { Cell } from "@tanstack/react-table";
import { ISupplyOrder } from "domain/Inventory/Models/ISupplyOrder";
import { ISupplyOrderSummary } from "domain/Inventory/Models/ISupplyOrderSummary";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { useGlobalInventoryContext } from "modules/Inventory/components/SBGlobalInventoryInfoModal";
import React, { forwardRef, useContext, useState } from "react";
import { SupplyOrderSummarization } from "../SupplyOrderSummarization";
import { useSupplyOrderHeaders } from "./useSupplyOrderHeaders";

import { ISupplyOrderTableProps } from "./models/ISupplyOrderTableProps";

const SupplyOrderTable = forwardRef(
	({ title, rows, containerHeight, summary, onScroll }: ISupplyOrderTableProps, ref: any) => {
		const { headers } = useSupplyOrderHeaders();
		const [selectedItems, setSelectedItems] = useState<ISupplyOrder[]>([]);
		const { openMenuByClientID, isOpen } = useContext(useGlobalInventoryContext);

		const handleClick = (cell: Cell<ISupplyOrder, any>) => {
			if (cell.column.id === "inventory")
				openMenuByClientID(cell.row.original.productClientID, cell.row.original.storeClientID);
		};

		return (
			<SBBox>
				<SupplyOrderSummarization
					summary={summary}
					selectedItems={selectedItems}
				/>
				<SBBox width={isOpen ? "50vw" : "100%"} style={{ transition: "all 0.25s ease", marginTop: "1rem" }}>
					<SBNewTable
						ref={ref}
						hasSelection
						virtualize
						title={title}
						startRows={rows}
						defaultColumns={headers}
						onClick={handleClick}
						onSelect={(_, indices) =>
							setSelectedItems(
								(indices as string[]).map((i) => rows[+i]),
							)
						}
						containerHeight={containerHeight}
						totalCount={summary?.totalCount}
						onScroll={onScroll}
					/>
				</SBBox>
			</SBBox>
		);
	},
);

export default SupplyOrderTable;
